module.exports = __webpack_public_path__ + "static/media/icon_water-leak.d73bb82e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_water-leak.svg
// module id = 87
// module chunks = 0